import { PageHeader } from '@/shared/layouts/PageHeader';
import { useUser } from '@/shared/hooks/useAuth';
import { DashboardLayoutEngine } from '../infrastructure/layout/DashboardLayoutEngine';
import { DashboardLayoutConfig } from '../infrastructure/contracts/layout.contract';
import { DashboardProvider } from '../infrastructure/hooks/DashboardProvider';
import { registerEmployeeWidgets } from '../widgets/employee/register';
import { registerSharedWidgets } from '../widgets/shared/registerSharedWidgets';

// Register widgets before rendering layout
registerEmployeeWidgets();
registerSharedWidgets();

const employeeLayout: DashboardLayoutConfig = {
  id: 'employee-default',
  name: 'Employee Layout',
  description: 'Default layout for employees',
  role: 'employee',
  widgets: [
    { id: 'dash-employee-overview', w: 12, h: 1, x: 0, y: 0 },
    { id: 'dash-time-summary', w: 12, h: 1, x: 0, y: 1 },
    { id: 'dash-ai-briefing', w: 12, h: 2, x: 0, y: 2 },
    { id: 'dash-upcoming-meetings', w: 12, h: 2, x: 0, y: 4 },
    { id: 'dash-notifications', w: 12, h: 2, x: 0, y: 6 },
    { id: 'dash-recent-activities', w: 12, h: 2, x: 0, y: 8 },
    { id: 'dash-pending-tasks', w: 12, h: 2, x: 0, y: 10 },
    { id: 'dash-active-projects', w: 12, h: 2, x: 0, y: 12 },
    { id: 'dash-running-jobs', w: 12, h: 2, x: 0, y: 14 },
    { id: 'dash-announcements', w: 12, h: 2, x: 0, y: 16 },
  ],
};

export function EmployeeDashboard() {
  const user = useUser();

  return (
    <DashboardProvider>
      <PageHeader
        title={`Welcome back, ${user?.displayName || 'Team Member'}`}
        description="Here is what's happening today."
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Dashboard' }]}
      />
      <div className="mt-6">
        <DashboardLayoutEngine layout={employeeLayout} />
      </div>
    </DashboardProvider>
  );
}
